import Vaults from './Vaults'

export default Vaults